import { useEffect, useState } from 'react';

import useTranslation from '../../../hooks/useTranslation';
import useAuth from '../../../hooks/useAuth';
import styles from './CookieConsent.module.css';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const { authenticated } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const hasConsent = localStorage.getItem('cookie-consent');
    if (!authenticated && !hasConsent) {
      setIsVisible(true);
    }
  }, [authenticated]);

  const acceptCookies = () => {
    setIsClosing(true);
    setTimeout(() => {
      localStorage.setItem('cookie-consent', 'true');
      setIsVisible(false);
      setIsClosing(false);
      // TODO: Здесь надо включить аналитику
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      data-cookie-consent
      className={`${styles.container} ${isClosing ? styles.closing : ''}`}
    >
      <div className={styles.inner}>
        <p className={styles.text}>
          {t('auth.cookie.text')}
          <a href="/privacy" className={styles.link}>{t('auth.cookie.link')}</a>
        </p>
        <button 
          onClick={acceptCookies}
          className={styles.button}
        >
          {t('auth.cookie.btn')}
        </button>
      </div>
    </div>
  );
};
